import React, { FunctionComponent } from 'react';
import { View } from 'react-native';
import { connect } from 'react-redux';
import { defaultScale } from '../../../utils/scaling';
import { pausePlayback, resumePlayback, shuffleOff, shuffleOn, skipBackward, skipForward } from './actions';
import { IPlayerState } from './interfaces';
import { MediaControlButton } from './MediaControlButton';
import { getMusicPlayerStateSelector } from './selectors';

interface IProps {
  playerState: IPlayerState;
  resumePlayback: () => void;
  pausePlayback: () => void;
  skipForward: () => void;
  skipBackward: () => void;
  shuffleOn: () => void;
  shuffleOff: () => void;
  setupScreen: boolean;
}

const MusicControlButtons: FunctionComponent<IProps> = ({ playerState, setupScreen = false, ...props }) => {

  const shuffleButton = () => {
    if (playerState.isShuffling) {
      return (
        <MediaControlButton disabled={!playerState.canToggleShuffle} icon={'random'}
                            onPress={props.shuffleOff} active={true}/>
      );
    }
    if (!playerState.isShuffling) {
      return (
        <MediaControlButton disabled={!playerState.canToggleShuffle} icon={'random'}
                            onPress={props.shuffleOn}/>
      );
    }
  };

  return (
    <View style={{
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      width: setupScreen ? '100%' : 'auto',
    }}>

      {!setupScreen && shuffleButton()}
      <MediaControlButton disabled={!playerState.canSkipPrevious} icon={'backward'}
                          onPress={props.skipBackward} size={setupScreen ? defaultScale(35) : undefined}/>
      {
        playerState.isPaused &&
        <MediaControlButton disabled={false} icon={'play'} onPress={props.resumePlayback}
                            size={setupScreen ? defaultScale(43) : undefined}/>
      }
      {
        !playerState.isPaused &&
        <MediaControlButton disabled={false} icon={'pause'} onPress={props.pausePlayback}
                            size={setupScreen ? defaultScale(43) : undefined}/>
      }
      <MediaControlButton disabled={!playerState.canSkipNext} icon={'forward'}
                          onPress={props.skipForward} size={setupScreen ? defaultScale(35) : undefined}/>
    </View>
  );
};

const mapStateToProps = (state: any): Partial<IProps> => {
  return {
    playerState: getMusicPlayerStateSelector(state),
  };
};

const mapDispatchToProps = (dispatch: any): Partial<IProps> => {
  return {
    resumePlayback: () => dispatch(resumePlayback()),
    pausePlayback: () => dispatch(pausePlayback()),
    skipBackward: () => dispatch(skipBackward()),
    skipForward: () => dispatch(skipForward()),
    shuffleOn: () => dispatch(shuffleOn()),
    shuffleOff: () => dispatch(shuffleOff()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MusicControlButtons);
